import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  pathPrefix = (window as any).WEBAPP_PATH
  headers = { 'X-Requested-With': 'XMLHttpRequest' }
  options = {
    headers: new HttpHeaders(this.headers),
  }

  constructor(private http: HttpClient) {}

  get(url: string, options: any = {}, shouldRemovePrefix?: boolean) {
    url = this.getUrl(shouldRemovePrefix, url)
    const requestOptions = this.setRequestOptions(options)
    return this.http.get(url, requestOptions)
  }

  delete(url: string, options?: any, shouldRemovePrefix?: boolean) {
    url = this.getUrl(shouldRemovePrefix, url)

    const requestOptions = this.setRequestOptions(options)
    return this.http.delete(url, requestOptions)
  }

  post(url: string, data: any, options?: any, shouldRemovePrefix?: boolean) {
    url = this.getUrl(shouldRemovePrefix, url)

    const requestOptions = this.setRequestOptions(options)
    return this.http.post(url, data, requestOptions)
  }

  patch(url: string, data: any, options?: any, shouldRemovePrefix?: boolean) {
    url = this.getUrl(shouldRemovePrefix, url)

    const requestOptions = this.setRequestOptions(options)
    return this.http.patch(url, data, requestOptions)
  }

  put(url: string, data: any, options?: any, shouldRemovePrefix?: boolean) {
    url = this.getUrl(shouldRemovePrefix, url)

    const requestOptions = this.setRequestOptions(options)
    return this.http.put(url, data, requestOptions)
  }

  setRequestOptions(options: any) {
    const headers = options?.headers
      ? new HttpHeaders({
          ...this.headers,
          ...options?.headers,
        })
      : this.options.headers

    return { ...options, headers: headers }
  }

  getUrl(shouldRemovePrefix: boolean | undefined, url: string): string {
    return shouldRemovePrefix ? url : this.pathPrefix + url
  }
}
